import { type NuxtError } from '#app'
import { type FieldErrors, type ModelData, dataToError } from '~~/models'

const useFieldErrors = () => {
  const { t } = useI18n()
  const errors = ref<FieldErrors>({})

  const setFieldErrors = (scope: string, error: NuxtError) => {
    const err = dataToError(error.data as ModelData)
    if (err.name !== 'ValidationError') return false
    
    if (err.code) {
      errors.value.form = [t(`${scope}.errors.${err.code}`)]
    }

    for (const field of err.data || []) {
      errors.value[field.name] = [
        t(`${scope}.errors.${field.name}_${field.code}`)
      ]
    }

    return true
  }

  return { errors, setFieldErrors }
}

export { useFieldErrors }
